export const COLORS = {
  PRIMARY: "#1C1C1C",
  SECONDARY: "#0157FF",
  WHITE: "#FFFFFF",
  TEXT_COLOR: "#27272730",
  PARAGRAPH_COLOR: "#8F8F8F",
  CARD_COLOR: "#F9F9F9",
};
